import { useQuery } from 'react-query';

import {
  GIFT_SUBSCRIPTION_SETTINGS_KEY,
  GiftSubscriptionReponse,
  giftSubscriptionSettings,
} from '@utils/backend-api/settings';

export default function useGiftSubscriptionSettings() {
  const { data: giftSubscriptionSetting, isLoading: isGiftSettingsLoading } =
    useQuery<GiftSubscriptionReponse>([GIFT_SUBSCRIPTION_SETTINGS_KEY], () =>
      giftSubscriptionSettings()
    );

  return { giftSubscriptionSetting, isGiftSettingsLoading };
}
